export default {
  // ? ======================
  // ? ======= Layout =======
  // ? ======================

  navigation: {
    '.logo': {
      margin: '1rem 0rem 0rem',
      '.image': {
        // filter: 'brightness(0) invert(1)',
        maxHeight: ['100px', '', '130px'],
        margin: '0rem',
        boxShadow: '0px 0px 20px 7px #ffffff63',
        background: '#ffffff4d',
        padding: '0.5rem'
      }
    },
    '.logoScrolled': {},
    '.navMenuLogo': {
      img: {
        // filter: 'brightness(0) invert(1)',
        maxHeight: '140px',
        marginBottom: '2rem'
      }
    },
    '.containerScrolled': {
      backgroundColor: 'dark'
    },

    '.smallNavMenu': {
      '.get-a-quote': {
        variant: 'buttons.primary',
        padding: '0.5rem',
        backgroundColor: 'primary',
        border: 'none'
      },
      '> div': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }
    }
  },

  footer: {
    backgroundColor: 'dark',
    color: 'white',
    paddingBottom: ['6rem', '', '', '1rem'],
    maxWidth: 'unset',
    borderTop: 'solid 5px',
    borderColor: 'secondary',
    '.logo': {
      //   filter: 'brightness(0) invert(1)'
    },
    '.column': {
      svg: {
        path: {
          fill: 'light'
        }
      }
    },
    '.multiButtonContainer': {
      a: {
        color: 'light',
        border: 'unset',
        fontFamily: 'BW Vivan Light',
        letterSpacing: '1px',
        fontWeight: '900',
        ':hover': {
          color: 'white'
        }
      }
    },
    '.bottomBar': {
      borderRadius: '0px',
      borderWidth: '2px',
      borderColor: 'primary'
    },
    '.contactDetails-container': {
      textAlign: 'left'
    },
    '.gonationLogo': {
      filter: 'brightness(0) invert(1)'
    }
  },

  ctaWidget: {
    zIndex: '999',
    color: 'white',

    'a:hover': {
      color: 'white'
    }
  },

  // ? ======================
  // ? ===== Reuseables =====
  // ? ======================

  title: {
    fontFamily: 'heading',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '-2px',
    fontSize: ['1.5rem', '2rem', '3rem', '4rem'],
    textAlign: ['left', 'left', 'left', 'left']
  },

  subtitle: {
    fontFamily: 'body',
    fontSize: ['1rem', '1.25rem', '1.5rem', '2rem'],
    textAlign: ['left', 'left', 'left', 'left'],
    fontWeight: '500',
    color: 'primary',
    textTransform: 'capitalize'
  },

  text: {
    textAlign: ['left', 'left', 'left', 'left'],
    fontSize: ['1rem'],
    margin: '1rem 0rem',
    color: '#484848'
  },

  sideBySide1: {
    height: ['', '', '100vh'],
    '.content': {
      alignItems: 'flex-start',
      justifyContent: 'center',
      textAlign: 'left',
      padding: ['1rem', '', '2rem', '3rem', '3.5rem']
    },
    '.title': {
      variant: 'customVariants.title'
    },
    '.subtitle': {
      variant: 'customVariants.subtitle'
    },
    '.text': {
      variant: 'customVariants.text'
    },
    '.ctaButton': {
      variant: 'buttons.primary'
    }
  },
  sideBySide2: {
    variant: 'customVariants.sideBySide1',
    '.content': {
      order: ['', '', '2']
    }
  },

  // ? ======================
  // ? ====== Homepage ======
  // ? ======================

  homepageHero: {
    '.innerContainer': {
      justifyContent: 'center',
      alignItems: 'center'
    },
    '.section': {
      justifyContent: 'center',
      alignItems: 'center',
      margin: '0rem auto',
      textAlign: 'center',
      maxWidth: 'unset',
      width: ['95%', '', '']
    },
    '.title': {
      variant: 'customVariants.title',
      fontSize: ['1.75rem', '2.5rem', '4rem', '5rem'],
      border: 'none',
      padding: '0rem'
    },
    '.subtitle': {
      variant: 'customVariants.subtitle',
      color: 'white'
    },
    '.text': {
      variant: 'customVariants.text',
      color: 'white'
    },
    '.ctaButton': {
      variant: 'buttons.primary'
    }
  },

  homepageShout: {
    variant: 'customVariants.sideBySide1',
    // '.content': {},
    '.title': {
      variant: 'customVariants.title',
      margin: '1rem 0rem'
    },

    '.text': {
      variant: 'customVariants.subtitle',
      margin: '1rem 0rem 2rem'
      // fontSize: ['1.2rem', '', '1.25rem'],
    },
    '.date': {
      textAlign: ['left', 'left', 'left', 'left'],
      opacity: '0.6',
      fontSize: ['1rem'],

      margin: '1rem 0rem'
    },

    '.shoutCTA': {
      variant: 'buttons.primary'
    }
  },

  homepageAbout: {
    variant: 'customVariants.sideBySide1'
  },
  homepageListings: {
    variant: 'customVariants.sideBySide2'
  },
  homepageSelling: {
    variant: 'customVariants.sideBySide1'
  },
  homepageGallery: {
    variant: 'customVariants.sideBySide2'
  },
  homepageContact: {
    variant: 'customVariants.sideBySide1',
    '.section': {
      justifyContent: 'center'
    },
    '.text': {
      p: {
        variant: 'customVariants.text',
        textAlign: ['right', 'right', 'right', 'right'],
        color: 'white',
        marginBottom: '1rem'
      }
    }
  },

  // ? ======================
  // ? ===== About page =====
  // ? ======================

  aboutSection: {},

  // ? ======================
  // ? ===== Events page ====
  // ? ======================

  events: {
    '.eventItemImage': {
      minHeight: 'unset'
    },
    '.eventDays, .eventDate': {
      color: 'black'
    }
  },

  // ? ======================
  // ? ===== Gallery page ====
  // ? ======================

  gallery: {
    padding: '1rem',
    '.albumsCTA': {
      width: ['', '', 'calc(50% - 1rem * 2)', '', 'calc(50% - 1.5rem * 2)'],
      alignItems: 'flex-end',
      justifyContent: 'flex-start',
      padding: '1rem',
      transition: 'all ease-in-out 0.6s',
      height: ['300px', '', '400px', '500px'],
      ':hover': {
        backgroundPosition: 'left top'
      }
    },
    '.albumTitle': {
      variant: 'customVariants.title',
      fontSize: ['1.25rem', '1.5rem', '1.75rem', '2rem']
    }
  },

  // ? ======================
  // ? ==== Listings page ===
  // ? ======================

  listings: {
    padding: '0rem',
    '.menuSectionTitle': {
      display: 'none'
    },
    '.menuItemButton': {
      variant: 'buttons.primary'
    },
    '.menuItemName': {
      variant: 'customVariants.title'
    },
    '.menuItemDescription': {
      variant: 'customVariants.text'
    },
    '.menuItemPage': {
      border: 'solid 1px',
      padding: ['1rem', '', '2rem', '3rem'],
      '> button': {
        variant: 'buttons.primary'
      }
    },
    '.menuItemPageItemName': {
      variant: 'customVariants.title',
      borderBottom: '1px solid'
    },
    '.menuItemPageImagesContainer': {
      margin: '1rem 0rem',
      justifyContent: 'flex-start'
    },
    '.menuItemPageContent': {
      margin: ' 1rem 0rem'
    }
  },

  // ? ======================
  // ? ==== contact page ====
  // ? ======================

  contactForm: {
    order: '2',
    h2: {
      textTransform: 'uppercase',
      color: 'text'
    },
    backgroundPosition: 'center center',
    color: 'dark',
    padding: ['3rem 1rem', '', '3rem 1rem'],
    '.text': {
      color: 'dark',
      marginBottom: '2rem',
      opacity: '0.8',
      lineHeight: '1.75'
    },
    '.inputField, .textField ': {
      fontWeight: '300',
      borderColor: 'dark',
      borderWidth: '2px',
      borderRadius: '0px',
      padding: '1rem 0.5rem',
      color: 'dark',
      '::placeholder': {
        color: 'dark'
      }
    }
  },

  sellingAbout: {
    variant: 'customVariants.sideBySide1',
    height: ['', '', 'auto'], // stops it being too tall and overwriting styles from variant
    background: 'unset',
    padding: '3rem 1rem 0rem'
  },
  buyingAbout: {
    variant: 'customVariants.sideBySide1',
    height: ['', '', 'auto'], // stops it being too tall and overwriting styles from variant
    background: 'unset',
    padding: '3rem 1rem 0rem'
  }
}
